export default "__VITE_ASSET__DgOYYg6S__"